"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractChatSpaceSection = ContractChatSpaceSection;
exports.InviteChatMemberModal = InviteChatMemberModal;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_hook_form_1 = require("react-hook-form");
const FormContext_1 = require("../../../View/Modals/FormContext");
const ChatMembersSelector_1 = require("../Modals/ChatMembersSelector");
const ConfirmModal_1 = __importDefault(require("../../../View/Modals/ConfirmModal"));
const chatSpacesService_1 = require("../Modals/chatSpacesService");
const ContractDetailsContext_1 = require("./ContractDetailsContext");
/**
 * Pokój Google Chat w widoku kontraktu ENVI: link „Otwórz czat", założenie albo podpięcie
 * pokoju, a gdy pokój jest - zmiana i odpięcie. Inne typy kontraktów: nic.
 * Stan pokoju serwer trzyma w `contract.chatSpaceId`; nazwę i link do pokoju czytamy
 * z listy `GET /contract/:id/chatSpaces`.
 */
function ContractChatSpaceSection() {
    const { contract, setContract, contractsRepository } = (0, ContractDetailsContext_1.useContractDetails)();
    const [dialog, setDialog] = (0, react_1.useState)("none");
    const [attached, setAttached] = (0, react_1.useState)(null);
    const ourContract = contract && "ourId" in contract ? contract : null;
    const chatSpaceId = ourContract?.chatSpaceId ?? null;
    (0, react_1.useEffect)(() => {
        setAttached(null);
        if (!ourContract?.id || !chatSpaceId)
            return;
        let cancelled = false;
        (0, chatSpacesService_1.fetchContractChatSpaces)(ourContract.id)
            .then((list) => {
            if (!cancelled)
                setAttached(list.find((space) => space.id === chatSpaceId) ?? null);
        })
            .catch(() => {
            // Brak odczytu nazwy nie może blokować nagłówka kontraktu.
        });
        return () => {
            cancelled = true;
        };
    }, [ourContract?.id, chatSpaceId]);
    if (!ourContract || !setContract)
        return null;
    const current = ourContract;
    const setCurrent = setContract;
    function applyChatSpaceId(nextId) {
        const updated = { ...current, chatSpaceId: nextId };
        setCurrent(updated);
        if (contractsRepository) {
            contractsRepository.items = contractsRepository.items.map((o) => (o.id === updated.id ? updated : o));
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        chatSpaceId ? (react_1.default.createElement(react_1.default.Fragment, null,
            attached?.uri ? (react_1.default.createElement(react_bootstrap_1.Button, { as: "a", variant: "outline-primary", size: "sm", href: attached.uri, target: "_blank", rel: "noopener noreferrer" }, "Otw\u00F3rz czat")) : (react_1.default.createElement("span", { className: "text-muted small" }, attached ? "Pokój bez zapisanego linku" : "Czat")),
            attached && react_1.default.createElement("span", { className: "text-muted small" }, attached.displayName),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-primary", size: "sm", onClick: () => setDialog("invite") }, "Dodaj osoby do czatu"),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", size: "sm", onClick: () => setDialog("change") }, "Zmie\u0144 pok\u00F3j"),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", size: "sm", onClick: () => setDialog("detach") }, "Odepnij pok\u00F3j"))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", size: "sm", onClick: () => setDialog("create") }, "Za\u0142\u00F3\u017C pok\u00F3j czatu"),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", size: "sm", onClick: () => setDialog("attach") }, "Podepnij pok\u00F3j czatu"))),
        dialog === "invite" && (react_1.default.createElement(InviteChatMemberModal, { contract: current, onClose: () => setDialog("none") })),
        dialog === "create" && (react_1.default.createElement(CreateChatSpaceModal, { contract: current, onClose: () => setDialog("none"), onCreated: (result) => applyChatSpaceId(result.chatSpace.id) })),
        (dialog === "attach" || dialog === "change") && (react_1.default.createElement(PickChatSpaceModal, { contract: current, replacing: dialog === "change", onClose: () => setDialog("none"), onChanged: applyChatSpaceId })),
        react_1.default.createElement(ConfirmModal_1.default, { show: dialog === "detach", onClose: () => setDialog("none"), title: "Odepnij pok\u00F3j czatu", prompt: react_1.default.createElement(react_1.default.Fragment, null,
                "Kontrakt przestanie by\u0107 powi\u0105zany z pokojem",
                attached ? ` „${attached.displayName}"` : "",
                ". Sam pok\u00F3j w Google Chat zostaje, nikt z niego nie jest usuwany."), confirmLabel: "Odepnij", onConfirm: async () => {
                await (0, chatSpacesService_1.detachContractChatSpace)(current.id);
                applyChatSpaceId(null);
            } })));
}
function InviteChatMemberModal({ contract, onClose }) {
    const methods = (0, react_hook_form_1.useForm)();
    const persons = methods.watch(ChatMembersSelector_1.CHAT_MEMBERS_FIELD, []);
    const [isWaiting, setIsWaiting] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const [members, setMembers] = (0, react_1.useState)(null);
    async function invite() {
        setIsWaiting(true);
        setError(null);
        setMembers(null);
        try {
            const result = await (0, chatSpacesService_1.inviteContractChatMembers)(contract.id, persons.map(person => person.id));
            setMembers(result.members);
        }
        catch (e) {
            setError(e instanceof Error ? e.message : "Nie udało się wysłać zaproszenia.");
        }
        finally {
            setIsWaiting(false);
        }
    }
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: true, onHide: isWaiting ? () => { } : onClose, backdrop: isWaiting ? "static" : true },
        react_1.default.createElement(FormContext_1.FormProvider, { value: methods },
            react_1.default.createElement(react_bootstrap_1.Form, { onSubmit: methods.handleSubmit(invite) },
                react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: !isWaiting },
                    react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "Dodaj osoby do czatu")),
                react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
                    react_1.default.createElement("p", null, "Wybierz osoby z bazy. PS wy\u015Ble zaproszenia na adresy ich aktywnych kont Google. Osoby z kontem Gmail musz\u0105 przyj\u0105\u0107 zaproszenie w Google Chat."),
                    react_1.default.createElement("fieldset", { disabled: isWaiting },
                        react_1.default.createElement(ChatMembersSelector_1.ChatMembersSelector, null)),
                    error && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", className: "mt-2 mb-0" }, error),
                    members?.map((member) => (react_1.default.createElement(react_bootstrap_1.Alert, { key: member.personId ?? member.email, variant: member.state === "JOINED" || member.state === "INVITED" ? "success" : "danger", className: "mt-2 mb-0", role: "status" },
                        member.displayName || member.email,
                        ": ",
                        (0, chatSpacesService_1.describeMemberState)(member))))),
                react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: onClose, disabled: isWaiting }, "Zamknij"),
                    react_1.default.createElement(react_bootstrap_1.Button, { type: "submit", variant: "primary", disabled: isWaiting || !persons.length || persons.length > 50 }, isWaiting ? react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_bootstrap_1.Spinner, { size: "sm", animation: "border" }),
                        " Wysy\u0142am\u2026") : "Wyślij zaproszenia"))))));
}
function CreateChatSpaceModal({ contract, onClose, onCreated, }) {
    const methods = (0, react_hook_form_1.useForm)();
    const persons = methods.watch(ChatMembersSelector_1.CHAT_MEMBERS_FIELD, []);
    const [scope, setScope] = (0, react_1.useState)("contract");
    const [typedName, setTypedName] = (0, react_1.useState)(null);
    const [isWaiting, setIsWaiting] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const [result, setResult] = (0, react_1.useState)(null);
    const suggestion = scope === "project"
        ? (0, chatSpacesService_1.suggestChatSpaceName)(contract._project?.ourId, contract._project?.alias, contract._project?.name)
        : (0, chatSpacesService_1.suggestChatSpaceName)(contract.ourId, contract.alias, contract.name);
    const shownName = typedName ?? suggestion;
    async function handleCreate() {
        setIsWaiting(true);
        setError(null);
        try {
            const created = await (0, chatSpacesService_1.createContractChatSpace)(contract.id, scope, shownName, persons.map(person => person.id));
            setResult(created);
            onCreated(created);
        }
        catch (e) {
            setError(e instanceof Error ? e.message : "Nie udało się założyć pokoju");
        }
        finally {
            setIsWaiting(false);
        }
    }
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: true, onHide: onClose },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "Za\u0142\u00F3\u017C pok\u00F3j czatu")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null, result ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", null,
                "Pok\u00F3j \u201E",
                result.chatSpace.displayName,
                "\" zosta\u0142 za\u0142o\u017Cony."),
            react_1.default.createElement("ul", { className: "mb-0" }, result.members.map((member) => (react_1.default.createElement("li", { key: member.email },
                member.email,
                ": ",
                (0, chatSpacesService_1.describeMemberState)(member))))))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_bootstrap_1.Form.Group, null,
                react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "radio", inline: true, name: "createScope", id: "createScope-contract", label: "Dla kontraktu", checked: scope === "contract", onChange: () => setScope("contract") }),
                react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "radio", inline: true, name: "createScope", id: "createScope-project", label: "Dla projektu", checked: scope === "project", onChange: () => setScope("project") })),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mt-2", controlId: "createChatSpaceName" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Nazwa pokoju"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "text", maxLength: chatSpacesService_1.CHAT_SPACE_NAME_MAX, value: shownName, onChange: (e) => setTypedName(e.target.value) })),
            react_1.default.createElement(FormContext_1.FormProvider, { value: methods },
                react_1.default.createElement(ChatMembersSelector_1.ChatMembersSelector, null)),
            react_1.default.createElement("div", { className: "text-muted small mt-1" }, "Do pokoju zostan\u0105 zaproszeni wybrane osoby oraz koordynator, administrator kontraktu i Ty."),
            error && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", className: "mt-2 mb-0" }, error))))),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: onClose }, result ? "Zamknij" : "Anuluj"),
            !result && (react_1.default.createElement(react_bootstrap_1.Button, { variant: "primary", onClick: handleCreate, disabled: isWaiting || !shownName.trim() || persons.length > 50 }, isWaiting ? react_1.default.createElement(react_bootstrap_1.Spinner, { size: "sm", animation: "border" }) : "Załóż pokój")))));
}
/** Podpięcie istniejącego pokoju; przy zmianie najpierw odpina stary (serwer odmawia podpięcia drugiego). */
function PickChatSpaceModal({ contract, replacing, onClose, onChanged, }) {
    const [spaces, setSpaces] = (0, react_1.useState)(null);
    const [selectedId, setSelectedId] = (0, react_1.useState)(0);
    const [isWaiting, setIsWaiting] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        let cancelled = false;
        (0, chatSpacesService_1.fetchContractChatSpaces)(contract.id)
            .then((list) => {
            if (cancelled)
                return;
            const candidates = list.filter((space) => !space.isAttachedToContract);
            setSpaces(candidates);
            setSelectedId(candidates[0]?.id ?? 0);
        })
            .catch((e) => {
            if (!cancelled)
                setError(e instanceof Error ? e.message : "Nie udało się wczytać pokoi");
        });
        return () => {
            cancelled = true;
        };
    }, [contract.id]);
    async function handleConfirm() {
        setIsWaiting(true);
        setError(null);
        let detached = false;
        try {
            if (replacing) {
                await (0, chatSpacesService_1.detachContractChatSpace)(contract.id);
                detached = true;
            }
            const space = await (0, chatSpacesService_1.attachContractChatSpace)(contract.id, selectedId);
            onChanged(space.id);
            onClose();
        }
        catch (e) {
            const message = e instanceof Error ? e.message : "Nie udało się podpiąć pokoju";
            if (detached) {
                onChanged(null);
                setError(`Poprzedni pokój odpięto, ale nie udało się podpiąć nowego: ${message}`);
            }
            else {
                setError(message);
            }
        }
        finally {
            setIsWaiting(false);
        }
    }
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: true, onHide: onClose },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, replacing ? "Zmień pokój czatu" : "Podepnij pokój czatu")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            spaces === null && !error && (react_1.default.createElement("div", { className: "text-muted small d-flex align-items-center gap-1" },
                react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm" }),
                react_1.default.createElement("span", null, "Wczytuj\u0119 pokoje\u2026"))),
            spaces !== null && spaces.length === 0 && (react_1.default.createElement("div", { className: "text-muted" }, "Nie ma innych pokoi do podpi\u0119cia.")),
            spaces !== null && spaces.length > 0 && (react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "pickChatSpace" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Pok\u00F3j"),
                react_1.default.createElement(react_bootstrap_1.Form.Select, { value: selectedId, onChange: (e) => setSelectedId(Number(e.target.value)) }, spaces.map((space) => (react_1.default.createElement("option", { key: space.id, value: space.id }, space.displayName)))),
                replacing && (react_1.default.createElement("div", { className: "text-muted small mt-1" }, "Obecny pok\u00F3j zostanie odpi\u0119ty od kontraktu; sam pok\u00F3j w Google Chat zostaje.")))),
            error && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", className: "mt-2 mb-0" }, error))),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: onClose }, "Anuluj"),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "primary", onClick: handleConfirm, disabled: isWaiting || !spaces || spaces.length === 0 || !selectedId }, isWaiting ? react_1.default.createElement(react_bootstrap_1.Spinner, { size: "sm", animation: "border" }) : replacing ? "Zmień" : "Podepnij"))));
}
